<template>
	<inertia-head title="Credit Card Information" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Credit Card Information</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Credit Card Information
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">

		<div v-if="flash && flash.title" class="shadow m-3 border border-default bg-white" :class="flash.title === 'Status Success' ? 'alert-success' : 'alert-danger'">
			<div class="content">
				<h3 class="alert-heading fs-5 fw-bold mb-1">{{ flash.title }}</h3>
				<p class="mb-0">
					{{ flash.message }}
				</p>
			</div>
		</div>

		<div class="block block-rounded">
			<div class="block-header text-center">
				<h3 class="block-title">CURRENT MEMBERSHIP</h3>
			</div>
			<div class="block-content bg-info-light text-center">
				<div class="h3 fw-bold mb-0">
					{{ member.current_rank }} {{ member.add_alias }}
				</div>
				<div class="fs-sm fw-semibold mb-3">
					Expiry: {{ member.expiry }}
				</div>
				<div class="fs-sm fw-semibold mb-3">
					{{member.membership_type}}
				</div>
			</div>
			<div class="block-content block-content-full">
				<p class="h5 text-center">Update your payment information and get 1 month free! We’ll be doing a temporary charge on your card for PHP50 to verify it. A refund will automatically happen within 24-48 hours.</p>
				<form @submit.prevent="advanceRenew">
					<div class="form-group mb-4">
						<label>Please provide your credit card information below:</label>
						<stripe @accept-token="acceptToken" ref="stripe" />
						<div v-if="form.errors.card" class="invalid-feedback d-block">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.card }}
						</div>
					</div>
					<div class="mb-4 text-end space-x-1">
						<button
							class="btn btn-alt-primary"
							:disabled="form.processing || !form.token"
						>
							<span v-if="!form.processing">Update Credit Card</span>
							<span v-else>
								<div class="spinner-border spinner-border-sm text-dark" role="status" >
									<span class="sr-only mr-1">Please wait...</span>
								</div>
								<span class="mx-2">Please wait...</span>
							</span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../Layouts/AuthLayout'
import Stripe from '../../Shared/Components/Stripe'
import { watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster'

export default {
	layout: AuthLayout,
	props: {
		member: Object,
		subscription: Object,
		flash: Object,
	},
	components: {
		Stripe,
	},
	setup(props) {
		const toast = createToaster();

		const form = useForm({
						subscription: props.subscription.prod_id,
						payment_method: 'CARD',
						token: null,
						action: 'renew'
					})

		const acceptToken = (token) => {
								form.token = token
							}

		const advanceRenew = () => {
						form.post(route('member.post.credit-card-info'), {
							// only: ['flash1'],
							// onSuccess: () => {
							// 	if(props.flash1.result=="success")
							// 	{
							// 		toast.show(props.flash1.message, { type: "success"});
							// 		setTimeout(() => Inertia.visit(route('member.home')), 4000);
							// 	}
							// }
						})
					}

		return {
			toast,
			form,
			advanceRenew,
			acceptToken,
		}
	},
}
</script>
